import {ref, reactive, computed, watch, watchEffect} from 'vue';
import {usePageResize} from "@/modules/reader/book/pageResize";
import {usePaging} from "@/modules/reader/book/paging";
import {useParser} from "@/modules/reader/annotations/parser";
import {useTool} from "@/modules/reader/tools/tools"
import {isTeacher} from "@/modules/api/auth";
const {pageResizeState} = usePageResize();
const { pageState, setPageCount } = usePaging();

export function useAnnotationHelper() {

    const {toolState} = useTool();

    const getResizedAnnotationPos = (domPos) => {
        return {
            left:`${domPos.left* pageResizeState.imgToBrowserScale}px`,
            top:`${domPos.top * pageResizeState.imgToBrowserScale}px`,
            width:`${domPos.width * pageResizeState.imgToBrowserScale}px`,
            height:(domPos.height === "auto") ? domPos.height : `${domPos.height * pageResizeState.imgToBrowserScale}px`
        }
    }

    /**
     * Common style for annotation button.
     * If hide=1 is set, the button should be invisible. Since some functions still need the existence of the button even though it's invisible,
     * e.g. in multiPageKaraoke, the playKaraoke button listens to watchEffect. So set visibility:hidden instead of display:none to hide it generally.
     * Note that hide=1 setting doesn't apply to all annotation button. It may be set in playKaraoke, playBlock, show(All)Hints or showResources buttons
     * Set pointer-events:none to make annotation buttons unselectable when drawing.
     *
     * Remark: somehow the button type annotation is enlarged around 15%, so scale down 15%....
     * But do not scale if the button is transparent, e.g. prichi_6au2tb @p.43-44 , prichi_6au3tb @p66-68, prichi_6au1tb @p.21-22
     * @param isHide
     * @returns {{visibility: string, "pointer-events": string}}
     */
    const styleAnnotationBtn = (isHide, isKeepOriginalScale)=> {
        return {
            "pointer-events":(toolState.isAllowed) ? "none" : "auto",
            "opacity": (toolState.isAllowed) ? 0.6 : 1,
            "visibility": isHide ? "hidden" : "visible",
            "transform": isKeepOriginalScale ? "scale(1)" : "scale(0.85)",
            "transformOrigin": "center center"
        }
    }


    /**
     * Show annotation if user role is teacher and t=1 is set in the annotation, or there is no t=1 assigned.
     */
    const isShowAnnot = (isTeacherOnly) => {
        return (isTeacherOnly !== undefined && isTeacherOnly === 1 && isTeacher())  || isTeacherOnly=== undefined
    }

    return {
        getResizedAnnotationPos,
        styleAnnotationBtn,
        isShowAnnot
    }
}